import styled from 'styled-components';

// COMPONENTS
import {Row} from '../../../../../../stories/components/hotels/common/Layouts/Layouts';

export const CheckBox = styled.input.attrs({type: 'checkbox'})(
  props => `
  height: 1.3rem;
  width: 1.3rem;
  margin-right: 0.75rem;
  padding-right: ${props.theme.spacing.xlarge};
  align-items: center;
  justify-content: center;
  border-radius: 0.2rem;
  display: inline-flex;
  cursor: pointer;
  &::checked {
    border: 0.1rem solid ${props.theme.colors.goBrandBlue.base};
    background-color: ${props.theme.colors.goBrandBlue.base};
  }
`,
);

// 🐨better names and remove unwanted html elements later
export const OuterWrapperDiv = styled.div(
  props => `
  border: none;
  background-color: ${props.isActive ? `#1958B6` : 'transparent'};
  padding:  0 ;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  position: sticky;
  top: 148px;
  z-index: 2;
`,
);

// 🐨better names and remove unwanted html elements later
export const InnerWrapperDiv = styled(Row)(
  props => `
  padding: 0 ;
  align-items: center;
  flex-direction:${props.isGroupFilters ? 'column' : 'row'};
  align-items:${props.isGroupFilters ? 'flex-start' : ''};
`,
);

// 🐨better names and remove unwanted html elements later

export const ItemWrapperDiv = styled(Row)(
  props => `
  padding:  0.7rem 1rem;
  align-items: center;
  position: relative;
`,
);

export const StyledCheckBox = styled(CheckBox)(
  props => `
  transform: scale(1.3);
`,
);

export const TextStyledSpan = styled.label(
  props => `
  font-size: ${props.theme.font.custom(16)};
  color: ${props.textColor || props.theme.colors.downriver.dark};
  font-weight: ${!props.isBold ? 'normal' : 'bold'};
  cursor:pointer;
  /* to fix font discrepancy – https://www.youtube.com/watch?v=jnV1u67_yVg*/
  // margin-top: -4px;
`,
);

export const TooltipDiv = styled.div`
  display: flex;
  z-index: 2;
  align-items: center;
  background: #3D3C3C;
  border-radius: 0.9rem;
  padding: 1.5rem;
  position: absolute;
  width: 36rem;
  top: 3rem;
  left: -2.1rem;
  font-size: 1.2rem;
  color: #fff;
  .arror-up {
    width: 0;
    height: 0;
    border-left: 0.8rem solid transparent;
    border-right: 0.8rem solid transparent;
    border-bottom: 1rem solid #3D3C3C;
    position: absolute;
    top: -0.8rem;
    left: 2rem;
  }
  .cm__modalClose {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 2.5rem;
      top: 1.7rem;
      width: 0.9rem;
      height: 0.9rem;
      z-index: 14;
      cursor: pointer;
  }
  .cm__modalClose:hover {
      opacity: 1;
  }
  .cm__modalClose:before,
  .cm__modalClose:after {
      position: absolute;
      left: 1.2rem;
      content: " ";
      height: 1.4rem;
      width: 0.2rem;
      background-color: rgba(255, 255, 255, 0.5);
  }
  .cm__modalClose:before {
      transform: rotate(45deg);
  }
  .cm__modalClose:after {
      transform: rotate(-45deg);
  }
}
`;
